import {handleActions} from 'redux-actions';
import actions from './ui.actions';

const DEFAULT_SCEEN_SIZE = 'desktop';

export const UI_SCREEN_SIZES = [
	{
		name: 'desktop',
		max: 9999999
	},
	{
		name: 'tablet',
		max: 1100
	},
	{
		name: 'mobile',
		max: 620
	}
];

const reducer = handleActions(
	{
		[actions.uiResized]: (state, {payload}) => ({
			...state,
			screenSize: UI_SCREEN_SIZES.reduce((accum, screenSize) => {
				// Find the last profile that the new size is under.
				if (payload < screenSize.max) {
					return screenSize.name;
				} else {
					return accum;
				}
			}, DEFAULT_SCEEN_SIZE)
		}),
		[actions.uiModal]: (state, {payload}) => ({
			...state,
			modal: payload || null,
			pickerCallback: payload ? state.pickerCallback : null, // Clear out callbacks/prefill on nullifying of modal
			pickerPrefill: payload ? state.pickerPrefill : null
		}),
		[actions.uiToggleUserMenu]: state => ({
			...state,
			userMenuShown: !state.userMenuShown
		}),
		[actions.uiShowUserMenu]: state => ({
			...state,
			userMenuShown: true
		}),
		[actions.uiMessage]: (state, {payload}) => ({
			...state,
			message: typeof payload === 'string' ? payload : payload.content,
			messageType: typeof payload === 'string' ? 'info' : payload.type,
			messageTime: new Date().getTime()
		}),
		[actions.uiPickerCallback]: (state, {payload}) => ({
			...state,
			pickerCallback: payload
		}),
		[actions.uiPickerPrefill]: (state, {payload}) => ({
			...state,
			pickerPrefill: payload
		}),
		[actions.uiPopup]: (state, {payload}) => ({
			...state,
			popup: payload
		})
	},
	{
		screenSize: DEFAULT_SCEEN_SIZE,
		modal: null,
		userMenuShown: false,
		message: null,
		pickerCallback: null,
		pickerPrefill: null,
		popup: null
	}
);

export default reducer;



// WEBPACK FOOTER //
// ./src/chrome/ui.reducers.js